// extracted by mini-css-extract-plugin
export default {"container_increase":"style_container_increase__3CMdA","amount":"style_amount__pLe9s","button":"style_button__AMnrP"};